import usePortalModal from 'hooks/usePortalModal.jsx';
import { functionUtils } from 'utils/func.js';
import withIframeResizer from '../popups/EventIframePopup/HOCs/withIframeResizer';

/**
 * NOTES
 * @install yarn add iframe-resizer
 */
import EventIframeCorePopup from '../popups/EventIframePopup/core';
const EventIframeResizerCorePopup = withIframeResizer(EventIframeCorePopup);

/**
 * NOTES
 * @install yarn add @iframe-resizer/react@5.3.2 @iframe-resizer/parent@5.3.2
 */
// import EventIframePopup from '../popups/EventIframePopup';
// const EventIframeResizerComponentPopup = withIframeResizer(EventIframePopup);

const EventIframeModal = ({
  isShow,
  modalStyles,
  modalOptions,
  actionClose,
  action,
}) => {
  const { closePortalModalName } = usePortalModal();

  const isBackdropOverlap = !modalOptions?.isFullScreenWithHeader;

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <EventIframeResizerCorePopup
      name={'EventIframeResizerCorePopup'}
      isOpen={isShow}
      modalStyles={modalStyles}
      modalOptions={modalOptions}
      onClose={handleOnClose}
      onClick={handleOnClick}
      isBackdropOverlap={isBackdropOverlap}
      zIndexBackdropOverlap={1075}
      zIndexModal={1076}
    />
  );
};

export default EventIframeModal;
